import { IPromoInfo, EPromoType } from '../../../types/newbuilding/promoInfo';

export const getAuthorName = (promo: IPromoInfo): string | null | undefined => {
  const cianMortgage = promo.promoType === EPromoType.CianMortgage;

  return cianMortgage ? 'Циан.Ипотека' : promo.authorName;
};
